import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '../../common/components/button/button.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
// import { MultiSelectDropdownComponent } from '../../common/components/multi-select-dropdown/multi-select-dropdown.component';
import { SelectDropdownComponent } from '../../common/components/select-dropdown/select-dropdown.component';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AdminService } from '../../../services/admin.service';
import { ActivatedRoute } from '@angular/router';
import { DeleteWithdrawDialogComponent } from './dialogs/delete-withdraw-dialog/delete-withdraw-dialog.component';
import { ApproveRejectPromptComponent } from './dialogs/approve-reject-prompt/approve-reject-prompt.component';
import { RevokePromptComponent } from './dialogs/revoke-prompt/revoke-prompt.component';
import { ArchivePromptComponent } from './dialogs/archive-prompt/archive-prompt.component';
import { RepublishPromptComponent } from './dialogs/republish-prompt/republish-prompt.component';
import { DateDifferencePipe } from '../../common/pipes/date-difference.pipe';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { LoaderComponent } from '../../common/components/loader/loader.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-prompt-management',
  standalone: true,
  imports: [MatButtonModule, ButtonComponent, MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, MatTabsModule, CommonModule, MatRadioModule, MatCheckboxModule, MatSlideToggleModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatSortModule, MatSelectModule, SelectDropdownComponent, DateDifferencePipe, NgMultiSelectDropDownModule, LoaderComponent, MatTooltipModule],
  providers: [MatDialogConfig],
  templateUrl: './prompt-management.component.html',
  styleUrl: './prompt-management.component.scss'
})
export class PromptManagementComponent implements OnInit {

  displayedColumns: string[] = ['prompt_name', 'category_name', 'created_by', 'prompt_status', 'action'];
  pendingPromptsDisplayedColumns: string[] = ['prompt_name', 'category_name', 'created_by', 'prompt_last_updated_on', 'action'];
  publishedPromptsDisplayedColumns: string[] = ['prompt_name', 'category_name', 'created_by', 'prompt_last_updated_on', 'avg_rating', 'runs', 'action'];
  revokedPromptsDisplayedColumns: string[] = ['prompt_name', 'category_name', 'created_by', 'revoked_by', 'avg_rating', 'runs', 'action'];
  archivedPromptsDisplayedColumns: string[] = ['prompt_name', 'category_name', 'created_by', 'archived_by', 'avg_rating', 'runs', 'action'];
  dataSource!: MatTableDataSource<any>;
  pendingPromptDataSource!: MatTableDataSource<any>;
  publishedPromptDataSource!: MatTableDataSource<any>;
  revokedPromptDataSource!: MatTableDataSource<any>;
  archivedPromptDataSource!: MatTableDataSource<any>;

  @ViewChild(MatSort) sort: MatSort = {} as MatSort; // MatSort for sorting
  @ViewChild(MatPaginator) paginator: MatPaginator = {} as MatPaginator;

  @ViewChild('pendingPaginator') pendingPaginator: MatPaginator = {} as MatPaginator;
  @ViewChild('pendingSort') pendingSort: MatSort = {} as MatSort;

  @ViewChild('publishedPaginator') publishedPaginator: MatPaginator = {} as MatPaginator;
  @ViewChild('publishedSort') publishedSort: MatSort = {} as MatSort;

  @ViewChild('revokedPaginator') revokedPaginator: MatPaginator = {} as MatPaginator;
  @ViewChild('revokedSort') revokedSort: MatSort = {} as MatSort;

  @ViewChild('archivedPaginator') archivedPaginator: MatPaginator = {} as MatPaginator;
  @ViewChild('archivedSort') archivedSort: MatSort = {} as MatSort;

  clearfilter: boolean = true;

  isLoading: boolean = false;

  dropDownCategories: any = [];
  statusList: any = [];
  selectedCat: any = [];
  selectedStatus: any = [];
  categoryDropdownSettings: any;
  statusDropdownSettings: any;

  creatorPrompts: any[] = [];
  pendingPrompts: any[] = [];
  publishedPromptsList: any[] = [];
  revokedPromptsList: any[] = [];
  archivedPromptsList: any[] = [];

  filteredCreatorPrompts: any;
  filteredPendingPrompts: any;
  filteredPublishedPrompts: any;
  filteredrevokedPrompts: any;
  filteredarchivedPrompts: any;


  creatorPromptsCategoryDropdownList: any = [];
  cratorPromptsCreatedByList: any = [];
  cratorPromptsStatusList: any = [
    {item_id: 'DRAFT', item_text: 'Draft'},
    {item_id: 'REVOKED', item_text: 'Revoked'},
    {item_id: 'REJECTED', item_text: 'Rejected'},
    {item_id: 'SUBMITTED', item_text: 'Submitted'},
    {item_id: 'PUBLISHED', item_text: 'Published'},
  ];

  pendingPromptsCategoryDropdownList: any = [];
  pendingPromptsCreatedByDropdownList: any = [];

  publishedPromptsCategoryDropdownList: any = [];
  publishedPromptsCreatedByDropdownList: any = [];
  publishedPromptsApprovedByDropdownList: any = [];

  revokedPromptsCategoryDropdownList: any = [];
  revokedPromptsCreatedByDropdownList: any = [];
  revokedPromptsRevokedByDropdownList: any = [];

  archivedPromptsCategoryDropdownList: any = [];
  archivedPromptsCreatedByDropdownList: any = [];
  archivedPromptsRevokedByDropdownList: any = [];

  activityStatusDropdownList: any = [
    {item_id: 'active', item_text: 'Active'},
    {item_id: 'inactive', item_text: 'Inactive'}
  ];

  selectedPublishedStatusActivities: any = [];
  selectedRevokedStatusActivities: any = [];
  selectedArchivedStatusActivities: any = [];

  selectedItems: any = [];
  selectedPromptCategoryItems: any = [];
  selectedPromptCreatedbyItems: any = [];
  selectedPromptStatusItems: any = [];

  selectedPendingCategoryItems:any = [];
  selectedPendingCreatedbyItems: any = [];

  selectedPublishedCategoryItems: any = [];
  selectedPublishedCreatedbyItems: any = [];
  selectedPublishedApprovedbyItems: any = [];

  selectedRevokedCategoryItems: any = [];
  selectedRevokedCreatedbyItems: any = [];
  selectedRevokedbyItems: any = [];

  selectedArchivedCategoryItems: any = [];
  selectedArchivedCreatedbyItems: any = [];
  selectedArchivedbyItems: any = [];


  dropdownSettings: IDropdownSettings = {};
  allCategoryDropdownSettings: IDropdownSettings = {};
  creatorPromptCreatedbyDropdownSettings: IDropdownSettings = {};
  creatorPromptStatusDropdownSettings: IDropdownSettings = {};
  statusActivitySettings: IDropdownSettings = {};

  // creator prompt pagination
  totalRecords: any = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20];
  pageNumbers: number[] = [];

  // pending approval pagination
  pendingApprTotalRecords: any = 0;
  pendingApprPageSize: number = 20;
  pendingApprpageIndex: number = 0;
  pendingApprpageSizeOptions: number[] = [5, 10, 20];
  pendingApprpageNumbers: number[] = [];

  // creator prompt pagination
  publishedTotalRecords: any = 0;
  publishedPageSize: number = 20;
  publishedPageIndex: number = 0;
  publishedPageSizeOptions: number[] = [5, 10, 20];
  publishedPageNumbers: number[] = [];

  // creator prompt pagination
  revokedTotalRecords: any = 0;
  revokedPageSize: number = 20;
  revokedPageIndex: number = 0;
  revokedPageSizeOptions: number[] = [5, 10, 20];
  revokedPageNumbers: number[] = [];

  // creator prompt pagination
  archivedTotalRecords: any = 0;
  archivedPageSize: number = 20;
  archivedPageIndex: number = 0;
  archivedPageSizeOptions: number[] = [5, 10, 20];
  archivedPageNumbers: number[] = [];

  @ViewChild('creatorPromptSearchInput') creatorPromptSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pendingApprPromptSearchInput') pendingApprPromptSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('publishedPromptSearchInput') publishedPromptSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('revokedPromptSearchInput') revokedPromptSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('archivedPromptSearchInput') archivedPromptSearchInput!: ElementRef<HTMLInputElement>;

  // sort variables
  creatorPromptSort:any = {
    promptNameAscSort: true,
    promptNameDesSort: true,
    createdByAscSort: true,
    createdByDesSort: true,
    categoryAscSort: true,
    categoryDesSort: true,
    statusAscSort: true,
    statusDesSort: true
  }

  pendingApprPromptSort:any = {
    promptNameAscSort: true,
    promptNameDesSort: true,
    createdByAscSort: true,
    createdByDesSort: true,
    categoryAscSort: true,
    categoryDesSort: true,
    submittedOnAscSort: true,
    submittedOnDesSort: true
  }

  publishedPromptSort:any = {
    promptNameAscSort: true,
    promptNameDesSort: true,
    createdByAscSort: true,
    createdByDesSort: true,
    categoryAscSort: true,
    categoryDesSort: true,
    approvedByAscSort: true,
    approvedByDesSort: true,
    avgRatingAscSort: true,
    avgRatingDesSort: true,
    totalUsageAscSort: true,
    totalUsageDesSort: true
  }
  
  revokedPromptSort:any = {
    promptNameAscSort: true,
    promptNameDesSort: true,
    createdByAscSort: true,
    createdByDesSort: true,
    categoryAscSort: true,
    categoryDesSort: true,
    revokedByAscSort: true,
    revokedByDesSort: true,
    avgRatingAscSort: true,
    avgRatingDesSort: true,
    totalUsageAscSort: true,
    totalUsageDesSort: true
  }
  
  archivedPromptSort:any = {
    promptNameAscSort: true,
    promptNameDesSort: true,
    createdByAscSort: true,
    createdByDesSort: true,
    categoryAscSort: true,
    categoryDesSort: true,
    archivedByAscSort: true,
    archivedByDesSort: true,
    avgRatingAscSort: true,
    avgRatingDesSort: true,
    totalUsageAscSort: true,
    totalUsageDesSort: true
  }

  //sort by variables
  creatorPromptSorting:any = {
    sort_by: '',
    order: '',
    search_text: ''
  }
  
  pendingApprPromptSorting:any = {
    sort_by: '',
    order: '',
    search_text: ''
  }
  
  publishedPromptSorting:any = {
    sort_by: '',
    order: '',
    search_text: ''
  }
  
  revokedPromptSorting:any = {
    sort_by: '',
    order: '',
    search_text: ''
  }
  
  archivedPromptSorting:any = {
    sort_by: '',
    order: '',
    search_text: ''
  }

  // first load api not called api multiple times
  isFirstLoad: any = {
    isCreatorCatFirstLoad: true,
    isCreatorCreatedByFirstLoad: true,
    isCreatorStatusFirstLoad: true,
  }
  
  isPendingApprFirstLoad: any = {
    isPendingApprCatFirstLoad: true,
    isPendingApprCreatedByFirstLoad: true,
  }
  
  ispublishedFirstLoad: any = {
    isPublishedCatFirstLoad: true,
    isPublishedCreatedByFirstLoad: true,
    isPublishedApprovedByFirstLoad: true,
    isPublishedActivityStatusFirstLoad: true,
  }
  
  isrevokedFirstLoad: any = {
    isrevokedCatFirstLoad: true,
    isrevokedCreatedByFirstLoad: true,
    isrevokedByFirstLoad: true,
    isRevokedActivityStatusFirstLoad: true
  }
  
  isarchivedFirstLoad: any = {
    isarchivedCatFirstLoad: true,
    isarchivedCreatedByFirstLoad: true,
    isarchivedByFirstLoad: true,
    isArchivedActivityStatusFirstLoad: true
  }

  // creatorPromptFilters
  creatorPromptsFilter: any = {
    category: [],
    created_by: [],
    prompt_state: ['DRAFT', 'SUBMITTED', 'REJECTED', 'REVOKED', 'PUBLISHED']
  }

  // pendingApprPromptFilters
  pendingApprPromptsFilter: any = {
    category: [],
    created_by: []
  }

  publishedPromptsFilter: any = {
    category: [],
    created_by: [],
    curator_id: [],
    activity_status: []
  }

  revokedPromptsFilter: any = {
    category: [],
    created_by: [],
    curator_id: [],
    activity_status: []
  }
  
  archivedPromptsFilter: any = {
    category: [],
    created_by: [],
    curator_id: [],
    activity_status: []
  }

  // search input variables
  creatorPromptSearchData: string = '';
  pendingPromptSearchData: string = '';
  publishedPromptSearchData: string = '';
  revokedPromptSearchData: string = '';
  archivedPromptSearchData: string = '';

  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public dialogConfig: MatDialogConfig
  ) {
  }

  ngOnInit(): void {

    this.allCategoryDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.creatorPromptCreatedbyDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.creatorPromptStatusDropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.statusActivitySettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.getAllRoles();
    this.getAllCategories();
    this.getCreatorPrompts();
    this.pendingApprovalPrompts();
    this.publishedPrompts();
    this.revokedPrompts();
    this.archivedPrompts();
  }

  getAllRoles() {
    const params:any = {
      role: [1,2,3,4]
    }
    this.adminService.getAllRoles(params).subscribe((resp:any) => {
      let allUsersRoles = resp.data?.users;
      this.cratorPromptsCreatedByList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2 || item.role_id == 3);
     
      
      this.pendingPromptsCreatedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2 || item.role_id == 3);

      this.publishedPromptsCreatedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2 || item.role_id == 3);
      this.publishedPromptsApprovedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2);

      this.revokedPromptsCreatedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2 || item.role_id == 3);
      this.revokedPromptsRevokedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1);

      this.archivedPromptsCreatedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1 || item.role_id == 2 || item.role_id == 3);
      this.archivedPromptsRevokedByDropdownList = allUsersRoles.filter((item:any) => item.role_id == 1);
    }, (error) => {
      // this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  getAllCategories() {
    // this.isLoading = true;
    this.adminService.getAllCategories().subscribe((resp:any) => {
      // this.isLoading = false;
      const filterActiveCat:any = resp?.data.filter((item:any) => item.is_active);
      this.creatorPromptsCategoryDropdownList = filterActiveCat;
      this.pendingPromptsCategoryDropdownList = filterActiveCat;
      this.publishedPromptsCategoryDropdownList = filterActiveCat;
      this.revokedPromptsCategoryDropdownList = filterActiveCat;
      this.archivedPromptsCategoryDropdownList = filterActiveCat;
    }, (error) => {
      // this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    });
  }

  clearSearch(tabName:any) {
    if (tabName === 'creatorPrompt' && this.creatorPromptSearchInput) {
      // this.creatorPromptSearchInput.nativeElement.value = '';
      // this.dataSource.filter = '';
      this.creatorPromptSearchData = '';
      this.creatorPromptSorting.search_text = '';
      this.pageIndex = 0;
      this.getCreatorPrompts();
    }
    else if (tabName === 'pendingApproval' && this.pendingApprPromptSearchInput) {
      // this.pendingApprPromptSearchInput.nativeElement.value = '';
      // this.pendingPromptDataSource.filter = '';
      this.pendingPromptSearchData = '';
      this.pendingApprPromptSorting.search_text = '';
      this.pendingApprpageIndex = 0;
      this.pendingApprovalPrompts();
    }
    else if (tabName === 'published' && this.publishedPromptSearchInput) {
      // this.publishedPromptSearchInput.nativeElement.value = '';
      // this.publishedPromptDataSource.filter = '';
      this.publishedPromptSearchData = '';
      this.publishedPromptSorting.search_text = '';
      this.publishedPageIndex = 0;
      this.publishedPrompts();
    }
    else if (tabName === 'revoked' && this.revokedPromptSearchInput) {
      // this.revokedPromptSearchInput.nativeElement.value = '';
      // this.revokedPromptDataSource.filter = '';
      this.revokedPromptSearchData = '';
      this.revokedPromptSorting.search_text = '';
      this.revokedPageIndex = 0;
      this.revokedPrompts();
    }
    else if (tabName === 'archived' && this.archivedPromptSearchInput) {
      // this.archivedPromptSearchInput.nativeElement.value = '';
      // this.archivedPromptDataSource.filter = '';
      this.archivedPromptSearchData = '';
      this.archivedPromptSorting.search_text = '';
      this.archivedPageIndex = 0;
      this.archivedPrompts();
    }
  }

  searchData(searchData:any, tabName:any) {
    if (tabName == 'creatorPrompt') {
      this.creatorPromptSorting.search_text = searchData;
      this.pageIndex = 0;
      this.getCreatorPrompts();
    }
    else if (tabName == 'pendingApproval') {
      this.pendingApprPromptSorting.search_text = searchData;
      this.pendingApprpageIndex = 0;
      this.pendingApprovalPrompts();
    }
    else if (tabName == 'published') {
      this.publishedPromptSorting.search_text = searchData;
      this.publishedPageIndex = 0;
      this.publishedPrompts();
    }
    else if (tabName == 'revoked') {
      this.revokedPromptSorting.search_text = searchData;
      this.revokedPageIndex = 0;
      this.revokedPrompts();
    }
    else if (tabName == 'archived') {
      this.archivedPromptSorting.search_text = searchData;
      this.archivedPageIndex = 0;
      this.archivedPrompts();
    }
  }

  onCreatorPromptSearchChange() {
    if (this.creatorPromptSearchData == '') {
      this.creatorPromptSorting.search_text = '';
      this.getCreatorPrompts();
    }
  }

  onPendingPromptSearchChange() {
    if (this.pendingPromptSearchData == '') {
      this.pendingApprPromptSorting.search_text = '';
      this.pendingApprovalPrompts();
    }
  }
  
  onPublishedPromptSearchChange() {
    if (this.publishedPromptSearchData == '') {
      this.publishedPromptSorting.search_text = '';
      this.publishedPrompts();
    }
  }
  
  onRevokedPromptSearchChange() {
    if (this.revokedPromptSearchData == '') {
      this.revokedPromptSorting.search_text = '';
      this.revokedPrompts();
    }
  }
  
  onArchivedPromptSearchChange() {
    if (this.archivedPromptSearchData == '') {
      this.archivedPromptSorting.search_text = '';
      this.archivedPrompts();
    }
  }

  // filter prompts
  sortingByAscCreatorPrompts(sortColumn:any) {
    this.pageIndex = 0;
    this.creatorPromptSort.promptNameAscSort = true
    this.creatorPromptSort.promptNameDesSort = true
    this.creatorPromptSort.categoryAscSort = true
    this.creatorPromptSort.categoryDesSort = true
    this.creatorPromptSort.createdByAscSort = true
    this.creatorPromptSort.createdByDesSort = true
    this.creatorPromptSort.statusAscSort = true
    this.creatorPromptSort.statusDesSort = true
    if (sortColumn == 'promptnameSort') {
      this.creatorPromptSort.promptNameAscSort = false
      this.creatorPromptSort.promptNameDesSort = true
      this.creatorPromptSorting.sort_by = 'prompt_name';
      this.creatorPromptSorting.order = 'asc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'catnameSort') {
      this.creatorPromptSort.categoryAscSort = false
      this.creatorPromptSort.categoryDesSort = true
      this.creatorPromptSorting.sort_by = 'category';
      this.creatorPromptSorting.order = 'asc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.creatorPromptSort.createdByAscSort = false
      this.creatorPromptSort.createdByDesSort = true
      this.creatorPromptSorting.sort_by = 'created_by';
      this.creatorPromptSorting.order = 'asc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'statusSort') {
      this.creatorPromptSort.statusAscSort = false
      this.creatorPromptSort.statusDesSort = true
      this.creatorPromptSorting.sort_by = 'status';
      this.creatorPromptSorting.order = 'asc';
      this.getCreatorPrompts();
    }
    
  }

  sortingByDesCreatorPrompts(sortColumn:any) {
    this.pageIndex = 0;
    this.creatorPromptSort.promptNameAscSort = true
    this.creatorPromptSort.promptNameDesSort = true
    this.creatorPromptSort.categoryAscSort = true
    this.creatorPromptSort.categoryDesSort = true
    this.creatorPromptSort.createdByAscSort = true
    this.creatorPromptSort.createdByDesSort = true
    this.creatorPromptSort.statusAscSort = true
    this.creatorPromptSort.statusDesSort = true
    if (sortColumn == 'promptnameSort') {
      this.creatorPromptSort.promptNameAscSort = true
      this.creatorPromptSort.promptNameDesSort = false
      this.creatorPromptSorting.sort_by = 'prompt_name';
      this.creatorPromptSorting.order = 'desc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'catnameSort') {
      this.creatorPromptSort.categoryAscSort = true
      this.creatorPromptSort.categoryDesSort = false
      this.creatorPromptSorting.sort_by = 'category';
      this.creatorPromptSorting.order = 'desc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.creatorPromptSort.createdByAscSort = true
      this.creatorPromptSort.createdByDesSort = false
      this.creatorPromptSorting.sort_by = 'created_by';
      this.creatorPromptSorting.order = 'desc';
      this.getCreatorPrompts();
    }
    else if (sortColumn == 'statusSort') {
      this.creatorPromptSort.statusAscSort = true
      this.creatorPromptSort.statusDesSort = false
      this.creatorPromptSorting.sort_by = 'status';
      this.creatorPromptSorting.order = 'desc';
      this.getCreatorPrompts();
    }
  }

  sortingByAscPendingApprPrompts(sortColumn:any) {
    this.pendingApprpageIndex = 0;
    this.pendingApprPromptSort.promptNameAscSort = true
    this.pendingApprPromptSort.promptNameDesSort = true
    this.pendingApprPromptSort.categoryAscSort = true
    this.pendingApprPromptSort.categoryDesSort = true
    this.pendingApprPromptSort.createdByAscSort = true
    this.pendingApprPromptSort.createdByDesSort = true
    this.pendingApprPromptSort.submittedOnAscSort = true
    this.pendingApprPromptSort.submittedOnDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.pendingApprPromptSort.promptNameAscSort = false
      this.pendingApprPromptSort.promptNameDesSort = true
      this.pendingApprPromptSorting.sort_by = 'prompt_name';
      this.pendingApprPromptSorting.order = 'asc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'catNameSort') {
      this.pendingApprPromptSort.categoryAscSort = false
      this.pendingApprPromptSort.categoryDesSort = true
      this.pendingApprPromptSorting.sort_by = 'category';
      this.pendingApprPromptSorting.order = 'asc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.pendingApprPromptSort.createdByAscSort = false
      this.pendingApprPromptSort.createdByDesSort = true
      this.pendingApprPromptSorting.sort_by = 'created_by';
      this.pendingApprPromptSorting.order = 'asc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'submittedOnSort') {
      this.pendingApprPromptSort.submittedOnAscSort = false
      this.pendingApprPromptSort.submittedOnDesSort = true
      this.pendingApprPromptSorting.sort_by = 'submitted_on';
      this.pendingApprPromptSorting.order = 'asc';
      this.pendingApprovalPrompts();
    }
  }

  sortingByDesPendingApprPrompts(sortColumn:any) {
    this.pendingApprpageIndex = 0;
    this.pendingApprPromptSort.promptNameAscSort = true
    this.pendingApprPromptSort.promptNameDesSort = true
    this.pendingApprPromptSort.categoryAscSort = true
    this.pendingApprPromptSort.categoryDesSort = true
    this.pendingApprPromptSort.createdByAscSort = true
    this.pendingApprPromptSort.createdByDesSort = true
    this.pendingApprPromptSort.submittedOnAscSort = true
    this.pendingApprPromptSort.submittedOnDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.pendingApprPromptSort.promptNameAscSort = true
      this.pendingApprPromptSort.promptNameDesSort = false
      this.pendingApprPromptSorting.sort_by = 'prompt_name';
      this.pendingApprPromptSorting.order = 'desc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'catNameSort') {
      this.pendingApprPromptSort.categoryAscSort = true
      this.pendingApprPromptSort.categoryDesSort = false
      this.pendingApprPromptSorting.sort_by = 'category';
      this.pendingApprPromptSorting.order = 'desc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.pendingApprPromptSort.createdByAscSort = true
      this.pendingApprPromptSort.createdByDesSort = false
      this.pendingApprPromptSorting.sort_by = 'created_by';
      this.pendingApprPromptSorting.order = 'desc';
      this.pendingApprovalPrompts();
    }
    else if (sortColumn == 'submittedOnSort') {
      this.pendingApprPromptSort.submittedOnAscSort = true
      this.pendingApprPromptSort.submittedOnDesSort = false
      this.pendingApprPromptSorting.sort_by = 'submitted_on';
      this.pendingApprPromptSorting.order = 'desc';
      this.pendingApprovalPrompts();
    }
  }

  sortingByAscPublishedPrompts(sortColumn:any) {
    this.publishedPageIndex = 0;
    this.publishedPromptSort.promptNameAscSort = true
    this.publishedPromptSort.promptNameDesSort = true
    this.publishedPromptSort.categoryAscSort = true
    this.publishedPromptSort.categoryDesSort = true
    this.publishedPromptSort.createdByAscSort = true
    this.publishedPromptSort.createdByDesSort = true
    this.publishedPromptSort.approvedByAscSort = true
    this.publishedPromptSort.approvedByDesSort = true
    this.publishedPromptSort.avgRatingAscSort = true
    this.publishedPromptSort.avgRatingDesSort = true
    this.publishedPromptSort.totalUsageAscSort = true
    this.publishedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.publishedPromptSort.promptNameAscSort = false
      this.publishedPromptSort.promptNameDesSort = true
      this.publishedPromptSorting.sort_by = 'prompt_name';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'catNameSort') {
      this.publishedPromptSort.categoryAscSort = false
      this.publishedPromptSort.categoryDesSort = true
      this.publishedPromptSorting.sort_by = 'category';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.publishedPromptSort.createdByAscSort = false
      this.publishedPromptSort.createdByDesSort = true
      this.publishedPromptSorting.sort_by = 'created_by';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'approvedBySort') {
      this.publishedPromptSort.approvedByAscSort = false
      this.publishedPromptSort.approvedByDesSort = true
      this.publishedPromptSorting.sort_by = 'approved_by';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.publishedPromptSort.avgRatingAscSort = false
      this.publishedPromptSort.avgRatingDesSort = true
      this.publishedPromptSorting.sort_by = 'avg_rating';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.publishedPromptSort.totalUsageAscSort = false
      this.publishedPromptSort.totalUsageDesSort = true
      this.publishedPromptSorting.sort_by = 'total_usage';
      this.publishedPromptSorting.order = 'asc';
      this.publishedPrompts();
    }
  }

  sortingByDesPublishedPrompts(sortColumn:any) {
    this.publishedPageIndex = 0;
    this.publishedPromptSort.promptNameAscSort = true
    this.publishedPromptSort.promptNameDesSort = true
    this.publishedPromptSort.categoryAscSort = true
    this.publishedPromptSort.categoryDesSort = true
    this.publishedPromptSort.createdByAscSort = true
    this.publishedPromptSort.createdByDesSort = true
    this.publishedPromptSort.approvedByAscSort = true
    this.publishedPromptSort.approvedByDesSort = true
    this.publishedPromptSort.avgRatingAscSort = true
    this.publishedPromptSort.avgRatingDesSort = true
    this.publishedPromptSort.totalUsageAscSort = true
    this.publishedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.publishedPromptSort.promptNameAscSort = true
      this.publishedPromptSort.promptNameDesSort = false
      this.publishedPromptSorting.sort_by = 'prompt_name';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'catNameSort') {
      this.publishedPromptSort.categoryAscSort = true
      this.publishedPromptSort.categoryDesSort = false
      this.publishedPromptSorting.sort_by = 'category';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.publishedPromptSort.createdByAscSort = true
      this.publishedPromptSort.createdByDesSort = false
      this.publishedPromptSorting.sort_by = 'created_by';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'approvedBySort') {
      this.publishedPromptSort.approvedByAscSort = true
      this.publishedPromptSort.approvedByDesSort = false
      this.publishedPromptSorting.sort_by = 'approved_by';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.publishedPromptSort.avgRatingAscSort = true
      this.publishedPromptSort.avgRatingDesSort = false
      this.publishedPromptSorting.sort_by = 'avg_rating';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.publishedPromptSort.totalUsageAscSort = true
      this.publishedPromptSort.totalUsageDesSort = false
      this.publishedPromptSorting.sort_by = 'total_usage';
      this.publishedPromptSorting.order = 'desc';
      this.publishedPrompts();
    }
  }
  
  sortingByAscRevokedPrompts(sortColumn:any) {
    this.revokedPageIndex = 0;
    this.revokedPromptSort.promptNameAscSort = true
    this.revokedPromptSort.promptNameDesSort = true
    this.revokedPromptSort.categoryAscSort = true
    this.revokedPromptSort.categoryDesSort = true
    this.revokedPromptSort.createdByAscSort = true
    this.revokedPromptSort.createdByDesSort = true
    this.revokedPromptSort.revokedByAscSort = true
    this.revokedPromptSort.revokedByDesSort = true
    this.revokedPromptSort.avgRatingAscSort = true
    this.revokedPromptSort.avgRatingDesSort = true
    this.revokedPromptSort.totalUsageAscSort = true
    this.revokedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.revokedPromptSort.promptNameAscSort = false
      this.revokedPromptSort.promptNameDesSort = true
      this.revokedPromptSorting.sort_by = 'prompt_name';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'categorySort') {
      this.revokedPromptSort.categoryAscSort = false
      this.revokedPromptSort.categoryDesSort = true
      this.revokedPromptSorting.sort_by = 'category';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.revokedPromptSort.createdByAscSort = false
      this.revokedPromptSort.createdByDesSort = true
      this.revokedPromptSorting.sort_by = 'created_by';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'revokedBySort') {
      this.revokedPromptSort.revokedByAscSort = false
      this.revokedPromptSort.revokedByDesSort = true
      this.revokedPromptSorting.sort_by = 'revoked_by';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.revokedPromptSort.avgRatingAscSort = false
      this.revokedPromptSort.avgRatingDesSort = true
      this.revokedPromptSorting.sort_by = 'avg_rating';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.revokedPromptSort.totalUsageAscSort = false
      this.revokedPromptSort.totalUsageDesSort = true
      this.revokedPromptSorting.sort_by = 'total_usage';
      this.revokedPromptSorting.order = 'asc';
      this.revokedPrompts();
    }
  }

  sortingByDesRevokedPrompts(sortColumn:any) {
    this.revokedPageIndex = 0;
    this.revokedPromptSort.promptNameAscSort = true
    this.revokedPromptSort.promptNameDesSort = true
    this.revokedPromptSort.categoryAscSort = true
    this.revokedPromptSort.categoryDesSort = true
    this.revokedPromptSort.createdByAscSort = true
    this.revokedPromptSort.createdByDesSort = true
    this.revokedPromptSort.revokedByAscSort = true
    this.revokedPromptSort.revokedByDesSort = true
    this.revokedPromptSort.avgRatingAscSort = true
    this.revokedPromptSort.avgRatingDesSort = true
    this.revokedPromptSort.totalUsageAscSort = true
    this.revokedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.revokedPromptSort.promptNameAscSort = true
      this.revokedPromptSort.promptNameDesSort = false
      this.revokedPromptSorting.sort_by = 'prompt_name';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'categorySort') {
      this.revokedPromptSort.categoryAscSort = true
      this.revokedPromptSort.categoryDesSort = false
      this.revokedPromptSorting.sort_by = 'category';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.revokedPromptSort.createdByAscSort = true
      this.revokedPromptSort.createdByDesSort = false
      this.revokedPromptSorting.sort_by = 'created_by';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'revokedBySort') {
      this.revokedPromptSort.revokedByAscSort = true
      this.revokedPromptSort.revokedByDesSort = false
      this.revokedPromptSorting.sort_by = 'revoked_by';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.revokedPromptSort.avgRatingAscSort = true
      this.revokedPromptSort.avgRatingDesSort = false
      this.revokedPromptSorting.sort_by = 'avg_rating';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.revokedPromptSort.totalUsageAscSort = true
      this.revokedPromptSort.totalUsageDesSort = false
      this.revokedPromptSorting.sort_by = 'total_usage';
      this.revokedPromptSorting.order = 'desc';
      this.revokedPrompts();
    }
  }

  sortingByAscArchivedPrompts(sortColumn:any) {
    this.archivedPageIndex = 0;
    this.archivedPromptSort.promptNameAscSort = true
    this.archivedPromptSort.promptNameDesSort = true
    this.archivedPromptSort.categoryAscSort = true
    this.archivedPromptSort.categoryDesSort = true
    this.archivedPromptSort.createdByAscSort = true
    this.archivedPromptSort.createdByDesSort = true
    this.archivedPromptSort.archivedByAscSort = true
    this.archivedPromptSort.archivedByDesSort = true
    this.archivedPromptSort.avgRatingAscSort = true
    this.archivedPromptSort.avgRatingDesSort = true
    this.archivedPromptSort.totalUsageAscSort = true
    this.archivedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.archivedPromptSort.promptNameAscSort = false
      this.archivedPromptSort.promptNameDesSort = true
      this.archivedPromptSorting.sort_by = 'prompt_name';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'categorySort') {
      this.archivedPromptSort.categoryAscSort = false
      this.archivedPromptSort.categoryDesSort = true
      this.archivedPromptSorting.sort_by = 'category';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.archivedPromptSort.createdByAscSort = false
      this.archivedPromptSort.createdByDesSort = true
      this.archivedPromptSorting.sort_by = 'created_by';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'archivedBySort') {
      this.archivedPromptSort.archivedByAscSort = false
      this.archivedPromptSort.archivedByDesSort = true
      this.archivedPromptSorting.sort_by = 'archived_by';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.archivedPromptSort.avgRatingAscSort = false
      this.archivedPromptSort.avgRatingDesSort = true
      this.archivedPromptSorting.sort_by = 'avg_rating';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.archivedPromptSort.totalUsageAscSort = false
      this.archivedPromptSort.totalUsageDesSort = true
      this.archivedPromptSorting.sort_by = 'total_usage';
      this.archivedPromptSorting.order = 'asc';
      this.archivedPrompts();
    }
  }

  sortingByDesArchivedPrompts(sortColumn:any) {
    this.archivedPageIndex = 0;
    this.archivedPromptSort.promptNameAscSort = true
    this.archivedPromptSort.promptNameDesSort = true
    this.archivedPromptSort.categoryAscSort = true
    this.archivedPromptSort.categoryDesSort = true
    this.archivedPromptSort.createdByAscSort = true
    this.archivedPromptSort.createdByDesSort = true
    this.archivedPromptSort.archivedByAscSort = true
    this.archivedPromptSort.archivedByDesSort = true
    this.archivedPromptSort.avgRatingAscSort = true
    this.archivedPromptSort.avgRatingDesSort = true
    this.archivedPromptSort.totalUsageAscSort = true
    this.archivedPromptSort.totalUsageDesSort = true
    if (sortColumn == 'promptNameSort') {
      this.archivedPromptSort.promptNameAscSort = true
      this.archivedPromptSort.promptNameDesSort = false
      this.archivedPromptSorting.sort_by = 'prompt_name';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'categorySort') {
      this.archivedPromptSort.categoryAscSort = true
      this.archivedPromptSort.categoryDesSort = false
      this.archivedPromptSorting.sort_by = 'category';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'createdBySort') {
      this.archivedPromptSort.createdByAscSort = true
      this.archivedPromptSort.createdByDesSort = false
      this.archivedPromptSorting.sort_by = 'created_by';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'archivedBySort') {
      this.archivedPromptSort.archivedByAscSort = true
      this.archivedPromptSort.archivedByDesSort = false
      this.archivedPromptSorting.sort_by = 'archived_by';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'avgRatingSort') {
      this.archivedPromptSort.avgRatingAscSort = true
      this.archivedPromptSort.avgRatingDesSort = false
      this.archivedPromptSorting.sort_by = 'avg_rating';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
    else if (sortColumn == 'totalUsageSort') {
      this.archivedPromptSort.totalUsageAscSort = true
      this.archivedPromptSort.totalUsageDesSort = false
      this.archivedPromptSorting.sort_by = 'total_usage';
      this.archivedPromptSorting.order = 'desc';
      this.archivedPrompts();
    }
  }

  // Creator prompts

  filteredCreatorPromptsList() {
    this.filteredCreatorPrompts = this.creatorPrompts.filter((record:any) => {
      const matchesCategory = this.selectedPromptCategoryItems.length === 0 || this.selectedPromptCategoryItems.some((item:any) => item.item_id === record.category_id);
      const matchesCreator = this.selectedPromptCreatedbyItems.length === 0 || this.selectedPromptCreatedbyItems.some((item:any) => item.item_id === record.creator_user_id);
      const matchesStatus = this.selectedPromptStatusItems.length === 0 || this.selectedPromptStatusItems.some((item:any) => item.item_id === record.prompt_status);

      return matchesCategory && matchesCreator && matchesStatus;
    });
    this.dataSource = new MatTableDataSource(this.filteredCreatorPrompts);
    this.setPaginatorAndSort();
  }

  onCreatorCategoryItemSelect(e: any) {
  
    if (this.isFirstLoad?.isCreatorCatFirstLoad) {
      this.isFirstLoad.isCreatorCatFirstLoad = false;
      return;
    }
    this.creatorPromptsFilter.category = e.map((item:any) => item.id);
    this.pageIndex = 0;
    this.getCreatorPrompts();
    // this.filteredCreatorPromptsList();
  }

  onCreatorCreatedbyItemSelect(e: any) {
  
    if (this.isFirstLoad?.isCreatorCreatedByFirstLoad) {
      this.isFirstLoad.isCreatorCreatedByFirstLoad = false;
      return;
    }
    this.creatorPromptsFilter.created_by = e.map((item:any) => item.id);
    
    this.pageIndex = 0;
    this.getCreatorPrompts();
    // this.filteredCreatorPromptsList();
  }

  onCreatorStatusItemSelect(e: any) {
   
    if (this.isFirstLoad?.isCreatorStatusFirstLoad) {
      this.isFirstLoad.isCreatorStatusFirstLoad = false;
      return;
    }
    this.creatorPromptsFilter.prompt_state = e.map((item:any) => item.item_id);
    if (!this.creatorPromptsFilter.prompt_state.length) {
      this.creatorPromptsFilter.prompt_state = ['DRAFT', 'SUBMITTED', 'REJECTED', 'REVOKED'];
    }
   
    // prompt_state: ['DRAFT', 'SUBMITTED', 'REJECTED', 'REVOKED']
    this.pageIndex = 0;
    this.getCreatorPrompts();
    // this.filteredCreatorPromptsList();
  }

  // Pending prompts

  filteredPendingPromptsList() {
    this.filteredPendingPrompts = this.pendingPrompts.filter((record:any) => {
      const matchesCategory = this.selectedPendingCategoryItems.length === 0 || this.selectedPendingCategoryItems.some((item:any) => item.item_id === record.category_id);
      const matchesCreatedBy = this.selectedPendingCreatedbyItems.length === 0 || this.selectedPendingCreatedbyItems.some((item:any) => item.item_id === record.creator_user_id);
      return matchesCategory && matchesCreatedBy;
    });
    this.pendingPromptDataSource = new MatTableDataSource(this.filteredPendingPrompts);
    this.setPaginatorAndSortForPendingPrompts();
  }

  onPendingPromptsCategoryItemSelect(e: any) {
   
    if (this.isPendingApprFirstLoad?.isPendingApprCatFirstLoad) {
      this.isPendingApprFirstLoad.isPendingApprCatFirstLoad = false;
      return;
    }
    this.pendingApprPromptsFilter.category = e.map((item:any) => item.id);
    this.pendingApprpageIndex = 0;
    this.pendingApprovalPrompts();
    // this.filteredPendingPromptsList();
  }

  onPendingPromptsCreatedbyItemSelect(e: any) {
    
    if (this.isPendingApprFirstLoad?.isPendingApprCreatedByFirstLoad) {
      this.isPendingApprFirstLoad.isPendingApprCreatedByFirstLoad = false;
      return;
    }
    this.pendingApprPromptsFilter.created_by = e.map((item:any) => item.id);
    this.pendingApprpageIndex = 0;
    this.pendingApprovalPrompts();
    // this.filteredPendingPromptsList();
  }

  // Published prompts

  filteredPublishedPromptsList() {
    this.filteredPublishedPrompts = this.publishedPromptsList.filter((record:any) => {
      const matchesCategory = this.selectedPublishedCategoryItems.length === 0 || this.selectedPublishedCategoryItems.some((item:any) => item.item_id === record.category_id);
      const matchesCreatedBy = this.selectedPublishedCreatedbyItems.length === 0 || this.selectedPublishedCreatedbyItems.some((item:any) => item.item_id === record.creator_user_id);
      const matchesApprovedBy = this.selectedPublishedApprovedbyItems.length === 0 || this.selectedPublishedApprovedbyItems.some((item:any) => item.item_id === record.curator_id);
      return matchesCategory && matchesCreatedBy && matchesApprovedBy;
    });
    this.publishedPromptDataSource = new MatTableDataSource(this.filteredPublishedPrompts);
    this.setPaginatorAndSortForPublishedPrompts();
  }

  onPublishedCategoryItemSelect(e: any) {
   
    if (this.ispublishedFirstLoad?.isPublishedCatFirstLoad) {
      this.ispublishedFirstLoad.isPublishedCatFirstLoad = false;
      return;
    }
    this.publishedPromptsFilter.category = e.map((item:any) => item.id);
    this.publishedPageIndex = 0;
    this.publishedPrompts();
    // this.filteredPublishedPromptsList();
  }

  onPublishedCreatedbyItemSelect(e: any) {
  
    if (this.ispublishedFirstLoad?.isPublishedCreatedByFirstLoad) {
      this.ispublishedFirstLoad.isPublishedCreatedByFirstLoad = false;
      return;
    }
    this.publishedPromptsFilter.created_by = e.map((item:any) => item.id);
    this.publishedPageIndex = 0;
    this.publishedPrompts();
    // this.filteredPublishedPromptsList();
  }

  onPublishedApprovedbyItemSelect(e: any) {
    
    if (this.ispublishedFirstLoad?.isPublishedApprovedByFirstLoad) {
      this.ispublishedFirstLoad.isPublishedApprovedByFirstLoad = false;
      return;
    }
    this.publishedPromptsFilter.curator_id = e.map((item:any) => item.id);
    this.publishedPageIndex = 0;
    this.publishedPrompts();
    // this.filteredPublishedPromptsList();
  }

  onPublishedActivityStatusItemSelect(e: any) {
    if (this.ispublishedFirstLoad?.isPublishedActivityStatusFirstLoad) {
      this.ispublishedFirstLoad.isPublishedActivityStatusFirstLoad = false;
      return;
    }
    this.publishedPromptsFilter.activity_status = e.map((item:any) => item.item_id);
    this.publishedPageIndex = 0;
    this.publishedPrompts();
  }

  // Revoked prompts

  filteredRevokedPromptsList() {
    this.filteredrevokedPrompts = this.revokedPromptsList.filter((record:any) => {
      const matchesCategory = this.selectedRevokedCategoryItems.length === 0 || this.selectedRevokedCategoryItems.some((item:any) => item.item_id === record.category_id);
      const matchesCreatedBy = this.selectedRevokedCreatedbyItems.length === 0 || this.selectedRevokedCreatedbyItems.some((item:any) => item.item_id === record.creator_user_id);
      const matchesRevokedBy = this.selectedRevokedbyItems.length === 0 || this.selectedRevokedbyItems.some((item:any) => item.item_id === record.curator_id);
      return matchesCategory && matchesCreatedBy && matchesRevokedBy;
    });
    this.revokedPromptDataSource = new MatTableDataSource(this.filteredrevokedPrompts);
      this.setPaginatorAndSortForRevokedPrompts();
  }

  onRevokedCategoryItemSelect(e: any) {

    if (this.isrevokedFirstLoad?.isrevokedCatFirstLoad) {
      this.isrevokedFirstLoad.isrevokedCatFirstLoad = false;
      return;
    }
    this.revokedPromptsFilter.category = e.map((item:any) => item.id);
    this.revokedPageIndex = 0;
    this.revokedPrompts();
    // this.filteredRevokedPromptsList();
  }

  onRevokedCreatedbyItemSelect(e: any) {

    if (this.isrevokedFirstLoad?.isrevokedCreatedByFirstLoad) {
      this.isrevokedFirstLoad.isrevokedCreatedByFirstLoad = false;
      return;
    }
    this.revokedPromptsFilter.created_by = e.map((item:any) => item.id);
    this.revokedPageIndex = 0;
    this.revokedPrompts();
    // this.filteredRevokedPromptsList();
  }

  onRevokedbyItemSelect(e: any) {
   
    if (this.isrevokedFirstLoad?.isrevokedByFirstLoad) {
      this.isrevokedFirstLoad.isrevokedByFirstLoad = false;
      return;
    }
    this.revokedPromptsFilter.curator_id = e.map((item:any) => item.id);
    this.revokedPageIndex = 0;
    this.revokedPrompts();
    // this.filteredRevokedPromptsList();
  }

  onRevokedActivityStatusItemSelect(e: any) {
    if (this.isrevokedFirstLoad?.isRevokedActivityStatusFirstLoad) {
      this.isrevokedFirstLoad.isRevokedActivityStatusFirstLoad = false;
      return;
    }
    this.revokedPromptsFilter.activity_status = e.map((item:any) => item.item_id);
    this.revokedPageIndex = 0;
    this.revokedPrompts();
  }

  // Archived prompts

  filteredArchivedPromptsList() {
    this.filteredarchivedPrompts = this.archivedPromptsList.filter((record:any) => {
      const matchesCategory = this.selectedArchivedCategoryItems.length === 0 || this.selectedArchivedCategoryItems.some((item:any) => item.item_id === record.category_id);
      const matchesCreatedBy = this.selectedArchivedCreatedbyItems.length === 0 || this.selectedArchivedCreatedbyItems.some((item:any) => item.item_id === record.creator_user_id);
      const matchesArchivedBy = this.selectedArchivedbyItems.length === 0 || this.selectedArchivedbyItems.some((item:any) => item.item_id === record.curator_id);
      return matchesCategory && matchesCreatedBy && matchesArchivedBy;
    });
    this.archivedPromptDataSource = new MatTableDataSource(this.filteredarchivedPrompts);
    this.setPaginatorAndSortForArchivedPrompts();
  }

  onArchivedCategoryItemSelect(e: any) {
   
    if (this.isarchivedFirstLoad?.isarchivedCatFirstLoad) {
      this.isarchivedFirstLoad.isarchivedCatFirstLoad = false;
      return;
    }
    this.archivedPromptsFilter.category = e.map((item:any) => item.id);
    this.archivedPageIndex = 0;
    this.archivedPrompts();
    // this.filteredArchivedPromptsList();
  }

  onArchivedCreatedbyItemSelect(e: any) {

    if (this.isarchivedFirstLoad?.isarchivedCreatedByFirstLoad) {
      this.isarchivedFirstLoad.isarchivedCreatedByFirstLoad = false;
      return;
    }
    this.archivedPromptsFilter.created_by = e.map((item:any) => item.id);
    this.archivedPageIndex = 0;
    this.archivedPrompts();
    // this.filteredArchivedPromptsList();
  }

  onArchivedbyItemSelect(e: any) {
   
    if (this.isarchivedFirstLoad?.isarchivedByFirstLoad) {
      this.isarchivedFirstLoad.isarchivedByFirstLoad = false;
      return;
    }
    this.archivedPromptsFilter.curator_id = e.map((item:any) => item.id);
    this.archivedPageIndex = 0;
    this.archivedPrompts();
    // this.filteredArchivedPromptsList();
  }

  onArchivedActivityStatusItemSelect(e: any) {
    if (this.isarchivedFirstLoad?.isArchivedActivityStatusFirstLoad) {
      this.isarchivedFirstLoad.isArchivedActivityStatusFirstLoad = false;
      return;
    }
    this.archivedPromptsFilter.activity_status = e.map((item:any) => item.item_id);
    this.revokedPageIndex = 0;
    this.archivedPrompts();
  }

  onPageChange(event: any) {
   
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getCreatorPrompts();
  }

  onPageChangeFromDropdown(event: any) {
    this.pageIndex = event.value;
    this.getCreatorPrompts();
  }

  getCreatorPrompts() {


    // this.route.queryParams.subscribe((params) => {
    const queryParams: any = {
      skip: (this.pageSize * this.pageIndex),
      limit: this.pageSize,
      prompt_state: this.creatorPromptsFilter?.prompt_state.length ? this.creatorPromptsFilter?.prompt_state : null,
      category: this.creatorPromptsFilter?.category.length ? this.creatorPromptsFilter?.category : null,
      created_by: this.creatorPromptsFilter?.created_by.length ? this.creatorPromptsFilter?.created_by : null,
      sort_by: this.creatorPromptSorting.sort_by != '' ? this.creatorPromptSorting.sort_by : null,
      order: this.creatorPromptSorting.order != '' ? this.creatorPromptSorting.order : null,
      search_text: this.creatorPromptSorting.search_text != '' ? this.creatorPromptSorting.search_text : null,
    }

    if (queryParams.prompt_state == null) {
      delete queryParams.prompt_state;
    }
    if (queryParams.category == null) {
      delete queryParams.category;
    }
    if (queryParams.created_by == null) {
      delete queryParams.created_by;
    }
    if (queryParams.sort_by == null) {
      delete queryParams.sort_by;
    }
    if (queryParams.order == null) {
      delete queryParams.order;
    }
    if (queryParams.search_text == null) {
      delete queryParams.search_text;
    }
    
    this.isLoading = true;
    this.adminService.getPrompts(queryParams).subscribe((resp: any) => {
      this.isLoading = false;
      this.creatorPrompts = resp.data?.prompts;
      
      

      this.totalRecords = resp?.data?.total_prompts;
      const totalPages = Math.ceil(this.totalRecords / this.pageSize);
      this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i);

      this.filteredCreatorPrompts = [...this.creatorPrompts];
      // this.dataSource = new MatTableDataSource(this.creatorPrompts);

      this.dataSource = JSON.parse(JSON.stringify(this.creatorPrompts));
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.setPaginatorAndSort();
      // this.creatorPromptsCategoryDropdownList = resp.data.prompts.map((item: any) => ({
      //   item_id: item.category_id,
      //   item_text: item.category_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );
      // console.log("this.creatorPromptsCategoryDropdownList", this.creatorPromptsCategoryDropdownList);


      // this.cratorPromptsCreatedByList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.creator_user_id,
      //     item_text: item.created_by
      //   }))
      //   .filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );
      // this.cratorPromptsStatusList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.prompt_status,
      //     item_text: item.prompt_status
      //   }))
      //   .filter((value: any, index:any, self:any) =>
      //     index === self.findIndex((t:any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );
      //   console.log(this.cratorPromptsStatusList);
        
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
    // });
  }

  onPendingApprPageChange(event: any) {
    
    this.pendingApprpageIndex = event.pageIndex;
    this.pendingApprPageSize = event.pageSize;

    this.pendingApprovalPrompts();
  }

  onPendingApprPageChangeFromDropdown(event: any) {
    this.pendingApprpageIndex = event.value;
    this.pendingApprovalPrompts();
  }
  pendingApprovalPrompts() {
    const queryParams: any = {
      skip: (this.pendingApprPageSize * this.pendingApprpageIndex),
      limit: this.pendingApprPageSize,
      prompt_state: ['SUBMITTED'],
      category: this.pendingApprPromptsFilter.category.length ? this.pendingApprPromptsFilter.category: null,
      created_by: this.pendingApprPromptsFilter.created_by.length ? this.pendingApprPromptsFilter.created_by : null,
      sort_by: this.pendingApprPromptSorting.sort_by != '' ? this.pendingApprPromptSorting.sort_by : null,
      order: this.pendingApprPromptSorting.order != '' ? this.pendingApprPromptSorting.order : null,
      search_text: this.pendingApprPromptSorting.search_text != '' ? this.pendingApprPromptSorting.search_text : null
    }

    if (queryParams.category == null) {
      delete queryParams.category;
    }
    if (queryParams.created_by == null) {
      delete queryParams.created_by;
    }
    if (queryParams.sort_by == null) {
      delete queryParams.sort_by;
    }
    if (queryParams.order == null) {
      delete queryParams.order;
    }
    if (queryParams.search_text == null) {
      delete queryParams.search_text;
    }

    this.isLoading = true;
    this.adminService.getPrompts(queryParams).subscribe((resp: any) => {
      this.isLoading = false;
      this.pendingPrompts = resp.data?.prompts;

      this.pendingApprTotalRecords = resp?.data?.total_prompts;
      const totalPages = Math.ceil(this.pendingApprTotalRecords / this.pendingApprPageSize);
      this.pendingApprpageNumbers = Array.from({ length: totalPages }, (_, i) => i);

      this.filteredPendingPrompts = [...this.pendingPrompts];

      this.pendingPromptDataSource = JSON.parse(JSON.stringify(this.pendingPrompts));
      // this.dataSource.paginator = this.paginator;
      this.pendingPromptDataSource.sort = this.pendingSort;

      // this.pendingPromptDataSource = new MatTableDataSource(this.pendingPrompts);
      this.setPaginatorAndSortForPendingPrompts();
      // this.pendingPromptsCategoryDropdownList = resp.data.prompts.map((item: any) => ({
      //   item_id: item.category_id,
      //   item_text: item.category_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );

      // this.pendingPromptsCreatedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.creator_user_id,
      //     item_text: item.created_by
      //   }))
      //   .filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );
      // console.log("this.pendingPromptsCategoryDropdownList", this.pendingPromptsCategoryDropdownList);
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  onPublishedPageChange(event: any) {
   
    this.publishedPageIndex = event.pageIndex;
    this.publishedPageSize = event.pageSize;

    this.publishedPrompts();
  }

  onPublishedPageChangeFromDropdown(event: any) {
    this.publishedPageIndex = event.value;
    this.publishedPrompts();
  }
  publishedPrompts() {
    const queryParams: any = {
      skip: (this.publishedPageSize * this.publishedPageIndex),
      limit: this.publishedPageSize,
      prompt_state: ['PUBLISHED'],
      category: this.publishedPromptsFilter.category.length ? this.publishedPromptsFilter.category: null,
      created_by: this.publishedPromptsFilter.created_by.length ? this.publishedPromptsFilter.created_by : null,
      curator_id: this.publishedPromptsFilter.curator_id.length ? this.publishedPromptsFilter.curator_id : null,
      activity_status: this.publishedPromptsFilter.activity_status.length ? this.publishedPromptsFilter.activity_status : null,
      sort_by: this.publishedPromptSorting.sort_by != '' ? this.publishedPromptSorting.sort_by : null,
      order: this.publishedPromptSorting.order != '' ? this.publishedPromptSorting.order : null,
      search_text: this.publishedPromptSorting.search_text != '' ? this.publishedPromptSorting.search_text : null
    }

    if (queryParams.category == null) {
      delete queryParams.category;
    }
    if (queryParams.created_by == null) {
      delete queryParams.created_by;
    }
    if (queryParams.curator_id == null) {
      delete queryParams.curator_id;
    }
    if (queryParams.activity_status == null) {
      delete queryParams.activity_status;
    }
    if (queryParams.sort_by == null) {
      delete queryParams.sort_by;
    }
    if (queryParams.order == null) {
      delete queryParams.order;
    }
    if (queryParams.search_text == null) {
      delete queryParams.search_text;
    }

    this.isLoading = true;
    this.adminService.getPrompts(queryParams).subscribe((resp: any) => {
      this.isLoading = false;
      this.publishedPromptsList = resp.data?.prompts;

      this.publishedTotalRecords = resp?.data?.total_prompts;
      const totalPages = Math.ceil(this.publishedTotalRecords / this.publishedPageSize);
      this.publishedPageNumbers = Array.from({ length: totalPages }, (_, i) => i);

      this.filteredPublishedPrompts = [...this.publishedPromptsList]
      // this.publishedPromptDataSource = new MatTableDataSource(this.publishedPromptsList);
      this.publishedPromptDataSource = JSON.parse(JSON.stringify(this.publishedPromptsList));
      this.publishedPromptDataSource.sort = this.publishedSort;
      this.setPaginatorAndSortForPublishedPrompts();

      // this.publishedPromptsCategoryDropdownList = resp.data.prompts.map((item: any) => ({
      //   item_id: item.category_id,
      //   item_text: item.category_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );

      // this.publishedPromptsCreatedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.creator_user_id,
      //     item_text: item.created_by
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );

      // this.publishedPromptsApprovedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.curator_id,
      //     item_text: item.curator_username
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  onRevokedPageChange(event: any) {
   
    this.revokedPageIndex = event.pageIndex;
    this.revokedPageSize = event.pageSize;

    this.revokedPrompts();
  }

  onRevokedPageChangeFromDropdown(event: any) {
    this.revokedPageIndex = event.value;
    this.revokedPrompts();
  }
  revokedPrompts() {
    const queryParams: any = {
      skip: (this.revokedPageSize * this.revokedPageIndex),
      limit: this.revokedPageSize,
      prompt_state: ['REVOKED'],
      category: this.revokedPromptsFilter.category.length ? this.revokedPromptsFilter.category: null,
      created_by: this.revokedPromptsFilter.created_by.length ? this.revokedPromptsFilter.created_by : null,
      curator_id: this.revokedPromptsFilter.curator_id.length ? this.revokedPromptsFilter.curator_id : null,
      activity_status: this.revokedPromptsFilter.activity_status.length ? this.revokedPromptsFilter.activity_status : null,
      sort_by: this.revokedPromptSorting.sort_by != '' ? this.revokedPromptSorting.sort_by : null,
      order: this.revokedPromptSorting.order != '' ? this.revokedPromptSorting.order : null,
      search_text: this.revokedPromptSorting.search_text != '' ? this.revokedPromptSorting.search_text : null
    }
    if (queryParams.category == null) {
      delete queryParams.category;
    }
    if (queryParams.created_by == null) {
      delete queryParams.created_by;
    }
    if (queryParams.curator_id == null) {
      delete queryParams.curator_id;
    }
    if (queryParams.activity_status == null) {
      delete queryParams.activity_status;
    }
    if (queryParams.sort_by == null) {
      delete queryParams.sort_by;
    }
    if (queryParams.order == null) {
      delete queryParams.order;
    }
    if (queryParams.search_text == null) {
      delete queryParams.search_text;
    }
    this.isLoading = true;
    this.adminService.getPrompts(queryParams).subscribe((resp: any) => {
      this.isLoading = false;
      this.revokedPromptsList = resp.data?.prompts;

      this.revokedTotalRecords = resp?.data?.total_prompts;
      const totalPages = Math.ceil(this.revokedTotalRecords / this.revokedPageSize);
      this.revokedPageNumbers = Array.from({ length: totalPages }, (_, i) => i);

      this.filteredrevokedPrompts = [...this.revokedPromptsList];
      // this.revokedPromptDataSource = new MatTableDataSource(this.revokedPromptsList);
      this.revokedPromptDataSource = JSON.parse(JSON.stringify(this.revokedPromptsList));
      this.revokedPromptDataSource.sort = this.revokedSort;
      this.setPaginatorAndSortForRevokedPrompts();

      // this.revokedPromptsCategoryDropdownList = resp.data.prompts.map((item: any) => ({
      //   item_id: item.category_id,
      //   item_text: item.category_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );

      // this.revokedPromptsCreatedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.creator_user_id,
      //     item_text: item.created_by
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );

      // this.revokedPromptsRevokedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.curator_id,
      //     item_text: item.curator_username
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  onArchivedPageChange(event: any) {
   
    this.archivedPageIndex = event.pageIndex;
    this.archivedPageSize = event.pageSize;

    this.archivedPrompts();
  }

  onArchivedPageChangeFromDropdown(event: any) {
    this.archivedPageIndex = event.value;
    this.archivedPrompts();
  }
  archivedPrompts() {
    const queryParams: any = {
      skip: (this.archivedPageSize * this.archivedPageIndex),
      limit: this.archivedPageSize,
      prompt_state: ['ARCHIVED'],
      category: this.archivedPromptsFilter.category.length ? this.archivedPromptsFilter.category: null,
      created_by: this.archivedPromptsFilter.created_by.length ? this.archivedPromptsFilter.created_by : null,
      curator_id: this.archivedPromptsFilter.curator_id.length ? this.archivedPromptsFilter.curator_id : null,
      activity_status: this.archivedPromptsFilter.activity_status.length ? this.archivedPromptsFilter.activity_status : null,
      sort_by: this.archivedPromptSorting.sort_by != '' ? this.archivedPromptSorting.sort_by : null,
      order: this.archivedPromptSorting.order != '' ? this.archivedPromptSorting.order : null,
      search_text: this.archivedPromptSorting.search_text != '' ?this.archivedPromptSorting.search_text : null
    }
    if (queryParams.category == null) {
      delete queryParams.category;
    }
    if (queryParams.created_by == null) {
      delete queryParams.created_by;
    }
    if (queryParams.curator_id == null) {
      delete queryParams.curator_id;
    }
    if (queryParams.activity_status == null) {
      delete queryParams.activity_status;
    }
    if (queryParams.sort_by == null) {
      delete queryParams.sort_by;
    }
    if (queryParams.order == null) {
      delete queryParams.order;
    }
    if (queryParams.search_text == null) {
      delete queryParams.search_text;
    }
    this.isLoading = true;
    this.adminService.getPrompts(queryParams).subscribe((resp: any) => {
      this.isLoading = false;
      this.archivedPromptsList = resp.data?.prompts;

      this.archivedTotalRecords = resp?.data?.total_prompts;
      const totalPages = Math.ceil(this.archivedTotalRecords / this.archivedPageSize);
      this.archivedPageNumbers = Array.from({ length: totalPages }, (_, i) => i);

      this.filteredarchivedPrompts =  [...this.archivedPromptsList];
      // this.archivedPromptDataSource = new MatTableDataSource(this.archivedPromptsList);
      this.archivedPromptDataSource = JSON.parse(JSON.stringify(this.archivedPromptsList));
      this.archivedPromptDataSource.sort = this.archivedSort;
      this.setPaginatorAndSortForArchivedPrompts();

      // this.archivedPromptsCategoryDropdownList = resp.data.prompts.map((item: any) => ({
      //   item_id: item.category_id,
      //   item_text: item.category_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );

      // this.archivedPromptsCreatedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.creator_user_id,
      //     item_text: item.created_by
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );

      // this.archivedPromptsRevokedByDropdownList = resp.data.prompts
      //   .map((item: any) => ({
      //     item_id: item.curator_id,
      //     item_text: item.curator_username
      //   })).filter((value: any, index: any, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.item_id === value.item_id && t.item_text === value.item_text
      //     ))
      //   );

    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  tabClick(event: any) {
   
    if (event?.tab?.textLabel == 'Creator Prompts') {
      this.getCreatorPrompts();
    } else if (event?.tab?.textLabel == 'Pending for Approval') {
      this.pendingApprovalPrompts();
    } else if (event?.tab?.textLabel == 'Published') {
      this.publishedPrompts();
    } else if (event?.tab?.textLabel == 'Revoked') {
      this.revokedPrompts();
    } else if (event?.tab?.textLabel == 'Archived') {
      this.archivedPrompts();
    }

  }

  setPaginatorAndSort(): void {
    // if (this.paginator && this.sort) {
    //   this.dataSource.paginator = this.paginator;
    //   this.dataSource.sort = this.sort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  setPaginatorAndSortForPendingPrompts(): void {
    // if (this.paginator && this.sort) {
    //   this.pendingPromptDataSource.paginator = this.pendingPaginator;
    //   this.pendingPromptDataSource.sort = this.pendingSort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  setPaginatorAndSortForPublishedPrompts(): void {
    // if (this.paginator && this.sort) {
    //   this.publishedPromptDataSource.paginator = this.publishedPaginator;
    //   this.publishedPromptDataSource.sort = this.publishedSort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  setPaginatorAndSortForRevokedPrompts(): void {
    // if (this.paginator && this.sort) {
    //   this.revokedPromptDataSource.paginator = this.revokedPaginator;
    //   this.revokedPromptDataSource.sort = this.revokedSort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  setPaginatorAndSortForArchivedPrompts(): void {
    // if (this.paginator && this.sort) {
    //   this.archivedPromptDataSource.paginator = this.archivedPaginator;
    //   this.archivedPromptDataSource.sort = this.archivedSort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  pendingPromptFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.pendingPromptDataSource.filter = filterValue.trim().toLowerCase();
  }

  publishedPromtsFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.publishedPromptDataSource.filter = filterValue.trim().toLowerCase();
  }

  revokePromptFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.revokedPromptDataSource.filter = filterValue.trim().toLowerCase();
  }
  archivedPromptFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.archivedPromptDataSource.filter = filterValue.trim().toLowerCase();
  }


  onChangeCategory(e: any) {
    this.selectedCat = e.value;
    
  }

  onChangeStatus(e: any) {
    this.selectedStatus = e.value;
    
  }

  withdrawPrompt(prompt: any) {
    prompt.isWithdraw = true;
    

    this.dialogConfig.data = prompt;
    this.dialogConfig.maxWidth = '472px';
    this.dialogConfig.width = '100%';
    this.dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(DeleteWithdrawDialogComponent, this.dialogConfig);

    dialogRef.afterClosed().subscribe((data: any) => {
   
      prompt.isWithdraw = false;
      if (data && data.status) {
       
        const promptId = data?.prompt_id;
        // delete data.prompt_id;
        this.isLoading = true;
        this.adminService.withdrawPrompts(data?.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
          
          this.openSnackbar(`Withdraw '${prompt?.prompt_name}' prompt successfully`, 'Withdraw Successfully', 'success-snackbar');
          this.getCreatorPrompts();
          this.pendingApprovalPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  deletePrompt(prompt?: any) {
    prompt.isDelete = true;
    const dialogRef = this.dialog.open(DeleteWithdrawDialogComponent, {
      data: prompt,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((data: any) => {
     
      prompt.isDelete = false;

      if (data && data.prompt_id) {
        this.isLoading = true;
        this.adminService.deletePrompt(data.prompt_id).subscribe((resp: any) => {
          this.isLoading = false;
          
          this.openSnackbar(`Deleted '${prompt?.prompt_name}' prompt successfully`, 'Deleted Successfully', 'success-snackbar');
          this.getCreatorPrompts();
          this.revokedPrompts();
          this.archivedPrompts();
          this.pendingApprovalPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  rejectPublishPrompt(prompt: any, isApprove: any) {
   
    prompt.isApprove = isApprove;

    const dialogRef = this.dialog.open(ApproveRejectPromptComponent, {
      data: prompt,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      

      if (data && data.status == 'REJECTED') {
        this.isLoading = true;
        this.adminService.rejectPrompts(data.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
         
          this.openSnackbar(`Rejected '${prompt?.prompt_name}' prompt successfully`, 'Rejected Successfully', 'success-snackbar');
          this.pendingApprovalPrompts();
          this.getCreatorPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      } else if (data && data.status == 'PUBLISHED') {
        this.isLoading = true;
        this.adminService.approvePrompts(data.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
          this.openSnackbar(`Published '${prompt?.prompt_name}' prompt successfully`, 'Published Successfully', 'success-snackbar');
          
          this.pendingApprovalPrompts();
          this.publishedPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    })
  }

  revokePrompt(prompt: any, isArchivetoRevoke?:any) {
    prompt.isArchivetoRevoke = isArchivetoRevoke;
    const dialogRef = this.dialog.open(RevokePromptComponent, {
      data: prompt,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data && data.status == 'REVOKED') {
        prompt.isArchivetoRevoke = false;
        this.isLoading = true;
        this.adminService.revokePrompts(data.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
          this.openSnackbar(`Revoked '${prompt?.prompt_name}' prompt successfully`, 'Revoked Successfully', 'success-snackbar');
          
          this.publishedPrompts();
          this.revokedPrompts();
          this.archivedPrompts();
          this.getCreatorPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  archivePrompt(prompt: any) {
    const dialogRef = this.dialog.open(ArchivePromptComponent, {
      data: prompt,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data && data.status == 'ARCHIVED') {
        this.isLoading = true;
        this.adminService.archivePrompts(data.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
          
          this.openSnackbar(`Archived '${prompt?.prompt_name}' prompt successfully`, 'Archived Successfully', 'success-snackbar');
          this.publishedPrompts();
          this.revokedPrompts();
          this.archivedPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  republishPrompt(prompt: any) {
    const dialogRef = this.dialog.open(RepublishPromptComponent, {
      data: prompt,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data && data.status == 'PUBLISHED') {
        this.isLoading = true;
        this.adminService.republishedPrompts(data.prompt_id, data).subscribe((resp: any) => {
          this.isLoading = false;
         
          this.openSnackbar(`Published '${prompt?.prompt_name}' prompt successfully`, 'Published Successfully', 'success-snackbar');
          this.archivedPrompts();
          this.publishedPrompts();
          this.revokedPrompts();
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  openSnackbar(message: string, title: string, cssClass: string) {
    const dialogRef = this.dialog.open(ErrorNotficationComponent, {
      data: {
        message: message,
        title: title,
        action_type: 'add',
        cssClass: cssClass
      }
    });
  }

  ngOnDestroy() {

  }

}
